export default "__VITE_ASSET__Cu9ttcMZ__"